module.exports = __webpack_public_path__ + "img/tx.rate.weekly.867cb731.png";